import * as yup from 'yup';

// Common image validation schema
const imageValidation = yup
  .mixed()
  .test("fileFormat", "Unsupported file format", (value) => {
    if (!value) return true;
    if (typeof value === "string") return true; // Allow URLs as strings
    if (!value.file) return false;

    const fileExtension = value.file.name.split(".").pop().toLowerCase();
    const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
    return supportedFormats.includes(fileExtension);
  })
  .nullable()

// Schema definition
const YupValidationTeam = yup.object().shape({
  role: yup.string().required("Role is required"),
  name: yup.string().required("Name is required"),
  social_link: yup.string().url("Invalid URL format").nullable().required(),
  social_icon: imageValidation.required("social icon is required"),
  img_src: imageValidation.required("image is required"),
  type: yup.string().nullable().required(),
  employee_id: yup.string().nullable(),
  order:yup.string().nullable().required('order is required.')
});

export default YupValidationTeam;
